
import { trimString } from '@q-dev/utils';

import AddressIcon from 'components/Custom/AddressIcon';

type Props = {
  address: string;
};

function WalletAddress ({ address }: Props) {
  return (
    <>
      <AddressIcon address={address} size={20} />
      <span>{trimString(address)}</span>
    </>
  );
}

export default WalletAddress;
